import {bool, func} from 'prop-types';
import {useCallback, useState} from 'react';

import {runAfterAnimations} from '../../utils/misc.js';
import ExerciseForm from '../ExerciseForm.jsx';
import Dialog from '../ui/Dialog.jsx';

export default function CustomExerciseModal({isOpen, onClose}) {
  const [success, setSuccess] = useState(false);

  const handleDone = useCallback(() => {
    onClose();

    runAfterAnimations(() => {
      setSuccess(false);
    });
  }, [onClose]);

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Create a custom exercise">
      {success && (
        <div>
          <h2 className="my-4 text-lg">Exercise created!</h2>
          <p>Your custom exercise is now available in the muscle group cards</p>
          <div className="mt-4 flex items-center justify-end gap-4">
            <button className="btn btn-accent btn-outline btn-sm" onClick={() => setSuccess(false)}>
              Create another
            </button>
            <button className="btn btn-accent btn-sm" onClick={handleDone}>
              Ok
            </button>
          </div>
        </div>
      )}

      {!success && <ExerciseForm onClose={onClose} onSuccess={() => setSuccess(true)} />}
    </Dialog>
  );
}

CustomExerciseModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};
